import React from 'react'
import './TopServices.css'
import RoundText from './RoundText'
import Kafel from './Kafel'
import DecoIco1 from '../images/svg/decoIco2.svg'
import DecoIco2 from '../images/svg/decoIco4.svg'
import DecoIco3 from '../images/svg/decoIco1.svg'
import DecoIco4 from '../images/svg/decoIco5.svg'
import DecoIco5 from '../images/svg/decoIco3.svg'




function TopServices() {
    return (
        <div className='top-services-main'>
            <div className='title-section'>
                <div className='col-one'>
                    <h3>
                        AI Systems <br />
                        <span className='row-two'>That Scale Your</span><br />
                        <span className='row-three'>Business</span>
                    </h3>
                </div>
                <div className='col-two'>
                    <p>
                        Built to automate content, conversations,<br /> and customer acquisition.
                    </p>
                </div>
                <div className='col-three'>

                    <RoundText
                        height='109px'
                        arrwidth='30px'
                    />

                </div>

            </div>
            <div className='kafle-section'>
                <div className='kafel-1'>
                    <Kafel
                        ico={DecoIco1}
                        title='Efficiency at Scale'
                        description='Do more without hiring more.
                        AI eliminates repetitive work, speeds up execution, and allows your team to focus on high-impact decisions instead of manual tasks.'
                    />
                </div>
                <div className='kafel-2'>
                    <Kafel
                        ico={DecoIco2}
                        title='Growth'
                        description="From random results to controlled systems.
                        AI transforms marketing into a structured process driven by data, optimization, and continuous improvement."
                    />
                </div>
                <div className='kafel-3'>
                    <Kafel
                        ico={DecoIco3}
                        title='24/7 Performance'
                        description='Your business never sleeps.
                        Automated systems capture leads, answer questions, and optimize campaigns around the clock - without burnout.'
                    />
                </div>
                <div className='kafel-4'>
                    <Kafel
                        ico={DecoIco4}
                        title='Intelligence'
                        description='No guesswork. Only signals.
                        AI analyzes behavior, performance, and trends in real time - helping you act on insights instead of assumptions.'
                    />
                </div>
                <div className='kafel-5'>
                    <Kafel
                        ico={DecoIco5}
                        title='Advantage'
                        description='The earlier you implement AI, the stronger your edge.AI systems learn, optimize, and improve over time - creating exponential, not linear growth.'
                    />
                </div>

            </div>


        </div>
    )
}

export default TopServices